import { render, staticRenderFns } from "./LoginMenuButtonNew.vue?vue&type=template&id=cb95853e&scoped=true"
import script from "./LoginMenuButtonNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginMenuButtonNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoginMenuButtonNew.vue?vue&type=style&index=0&id=cb95853e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb95853e",
  null
  
)

export default component.exports